import { IAlertsState, IGeneralAlerts } from './state';

export const getBMTAlerts = (state: { bmtAlertsState: IAlertsState }): IGeneralAlerts[] => state.bmtAlertsState.alerts.generalAlerts;

export const isFetchingAlerts = (state: { bmtAlertsState: IAlertsState }): boolean => state.bmtAlertsState.isFetchingAlerts;

export const alertErrors = (state: { bmtAlertsState: IAlertsState }): string => state.bmtAlertsState.errors;
